import React from "react";

const ControlCalendarComponent = React.lazy(
  () => import("../../../../../components/control-calendar/components/page"),
);

export const controlCalendarRoutes = [
  {
    path: "",
    element: <ControlCalendarComponent />,
  },
];
